module.exports = __webpack_public_path__ + "img/charter-airline.eea675a6.png";